/* DillySocks — Slider/Drawer von rechts (gemeinsame Basis).

   Optik: die bestehenden .ds-qadd-Klassen (Scrim + Aside, Kopf mit Titel
   und rundem Schliessen-Button, scrollbarer Body) aus dillysocks-tokens.css.
   Genutzt vom Quick-Add-Slider (ds-quick-add.js) und vom Bundle-Picker
   "Weiteres Design hinzufuegen" (ds-pdp-bundle.js). Jede Instanz bringt nur
   ihren Body-Inhalt mit; Oeffnen/Schliessen (Klick auf Scrim/X, Escape) und
   Fokus liegen hier — einmal statt in jedem Feature.

   window.dsDrawer.create({ title, className, ariaLabel, onClose }) ->
     { aside, scrim, head, body, open(), close(), isOpen() }

   Kein Modul: klassisches Script, damit es vor den Modul-Scripts der
   Features verfuegbar ist (guard gegen Doppel-Laden). */
(function () {
  'use strict';
  if (window.dsDrawer) return;

  function create(opts) {
    opts = opts || {};
    var scrim = document.createElement('div');
    scrim.className = 'ds-qadd-scrim';

    var aside = document.createElement('aside');
    aside.className = 'ds-qadd' + (opts.className ? ' ' + opts.className : '');
    aside.setAttribute('aria-hidden', 'true');
    aside.setAttribute('role', 'dialog');
    aside.setAttribute('aria-label', opts.ariaLabel || opts.title || '');

    var head = document.createElement('div');
    head.className = 'ds-qadd__head';
    head.innerHTML =
      '<h2 class="ds-qadd__title"></h2>' +
      '<button type="button" class="ds-qadd__close" aria-label="Schliessen"><i class="fa-solid fa-xmark" aria-hidden="true"></i></button>';
    head.querySelector('.ds-qadd__title').textContent = opts.title || '';

    var body = document.createElement('div');
    body.className = 'ds-qadd__body';

    aside.appendChild(head);
    aside.appendChild(body);
    document.body.appendChild(scrim);
    document.body.appendChild(aside);

    function isOpen() {
      return aside.classList.contains('is-open');
    }
    function close() {
      if (!isOpen()) return;
      aside.classList.remove('is-open');
      aside.setAttribute('aria-hidden', 'true');
      scrim.classList.remove('is-open');
      if (typeof opts.onClose === 'function') opts.onClose();
    }
    function open() {
      aside.classList.add('is-open');
      aside.setAttribute('aria-hidden', 'false');
      scrim.classList.add('is-open');
      var c = head.querySelector('.ds-qadd__close');
      if (c) c.focus({ preventScroll: true });
    }

    scrim.addEventListener('click', close);
    head.querySelector('.ds-qadd__close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !isOpen()) return;
      /* Ein Feature kann Escape selbst abfangen (z.B. Groessentabelle im
         Quick-Add zuerst schliessen): dann e.defaultPrevented setzen. */
      if (e.defaultPrevented) return;
      close();
    });

    return { aside: aside, scrim: scrim, head: head, body: body, open: open, close: close, isOpen: isOpen };
  }

  window.dsDrawer = { create: create };
})();
